<template>
  <div class="shogi-cell"
    :class="[komaName,isEnemy? 'enemy':'',{'legalMove':isLegalMove},{'mouseOver':isMouseOver},{'promotable':isPromotable}]" 
    @click.left="handleClick"
    @click.right.prevent="handleRightClick"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave">
    <img :src="img==='empty'? '':img" alt="">
  </div>
</template>

<script>
import CellDomain from 'common/cellDomain';
import {mapState} from 'vuex';
const shogiUtil = require('common/shogiUtil');

export default {
  name: 'shogiCell',
  props: {
    boardName:String,
    komaName: String,
    img: String,
    index: Number,
    isEnemy: Boolean,
  },
  data(){
    return {
      isMouseOver:false,
      isLegalMove:false,
      isPromotable:false
    }
  },
  computed: { 
    ...mapState([
        'moveableList',
        'boardLock',
        'allPromotableFlag',
        'selectedCell'
    ])
  },
  watch:{ 
    moveableList: function(newList) {
      if(newList.includes(this.index)){
          this.isLegalMove=true;
          this.isPromotable=this.allPromotableFlag || shogiUtil.isPromoable(this.selectedCell.komaName,this.index);
      } else{
          this.isLegalMove=false;
          this.isMouseOver=false;
          this.isPromotable=false;
      }
    }
  },
  methods:{
      handleClick: function(event,isRightClick=false){
        if(this.boardLock){
          return;
        }
          // クリックされたオブジェクトを作成
        const clickedCell= new CellDomain(
          // 駒名
          this.komaName,
          // 敵かどうか
          this.isEnemy,
          // 順番
          this.index,
          // shogiBoar | komaBoard
          this.boardName
        );
        if(this.isLegalMove && isRightClick){
          // Alert when you right click a unpromotable positon
          if(!this.isPromotable){
            this.$emit('cellError',{errorType:'illegalPromotionError'});
            return;
          }
          // Promote Koma
          this.$emit('cellClicked',{clickedCell,promoteKoma:true});
        }
        this.$emit('cellClicked',{clickedCell,promoteKoma:false});
      },
      // Right click means perform promotion
      handleRightClick: function(event){
        this.handleClick(event,true);
      },
      handleMouseEnter: function(){
        if(this.isLegalMove){
            this.isMouseOver=true;
        }
      },
      handleMouseLeave: function(){
        if(this.isLegalMove){
            this.isMouseOver=false;
        }
    }
  }
}
</script>

<style scoped> 
  .enemy {
    -webkit-transform:rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  .mouseOver.legalMove {
    mix-blend-mode:multiply;
  }
  .legalMove {
    background-color:grey;
    mix-blend-mode: screen;
  }
  .legalMove.promotable{
    background-color:rgb(243, 6, 223);  
  }
</style>
